import OutlineContent from './OutlineContent';

export default OutlineContent;
